import React from "react";
import { CoordinateSystem } from "./CoordinateSystem";
import { Zaunlinien } from "./Zaunlinien";
import { MoveableTeil } from "./MoveableTeil";

export function GrundrissZeichnung({
  cs,
  hide = false,
  rect,
  forSnapshot = false,
}: {
  cs: CoordinateSystem;
  hide: boolean;
  rect: { width: number; height: number };
  forSnapshot?: boolean;
}) {
  if (hide) return <></>;
  return (
    <div id="cfg" className="grundriss-zeichnung">
      <div
        className="stage2d grid-fullscreen"
        style={{
          touchAction: "none",
          position: "absolute",
          width: rect.width + "px",
          height: rect.height + "px",
        }}
      >
        {APP.arrangement.aufbauten.map((aufbau, index) => (
          <MoveableTeil
            key={aufbau.Key}
            cs={cs}
            aufbau={aufbau}
            modus={"zeichnen"}
            setInsideOperation={() => {}}
            selected={false}
            setSelected={() => {}}
            setAufbautenChange={() => {}}
          />
        ))}

        {cs && (
          <Zaunlinien
            cs={cs}
            editedKanteId={null}
            setEditedKanteId={(v) => {}}
            forSnapshot={forSnapshot}
          />
        )}
      </div>
    </div>
  );
}
